var account_bookings = ( function( $ ) {

	var switching_tabs = false;

	var _init = function() {
		_setup_tabs();
		_setup_workshops_toggle();

		_maybe_open_workshops();
	};

	var _setup_tabs = function() {
		var $tab_links    =  $( '#account-bookings' ).find( '.tabs' ),
			$tabs_content =  $( '#account-bookings' ).find( '.tabs-content' );

		$tab_links.find( 'a' ).on( 'click', function( e ) {
			e.preventDefault();

			if ( $( this ).hasClass( 'active' ) || switching_tabs ) {
				return;
			}

			switching_tabs = true;

			var $tab_content = $tabs_content.find( '.tab-content.' + $( this ).data( 'tab' ) );

			$tab_links.find( 'a' ).removeClass( 'active' );

			$tabs_content.find( '.tab-content' ).fadeOut( 400 );

			setTimeout( function(  ) {
				$tabs_content.find( '.tab-content' ).removeClass( 'active' )
			}, 410 );

			setTimeout( function() {
				$tab_content.fadeIn();
				$tab_content.addClass( 'active' );

				switching_tabs = false;
			}, 410 );

			$( this ).addClass( 'active' );
		} );
	};

	var _setup_workshops_toggle = function() {
		var $workshops = $( '.booking-card' ).find( '.workshops' );

		$workshops.find( 'a.toggle-workshops' ).on( 'click', _toggle_workshops );
	};

	var _toggle_workshops = function( e ) {
		var $container = $( this ).closest( '.workshops' );

		e.preventDefault();

		$container.hasClass( 'open' )
			? _close_workshops( $container )
			: _open_workshops( $container );
	};

	var _open_workshops = function( $container ) {
		$container.addClass( 'open' );
		$container.find( '.workshops-collapse' ).slideDown();
	};

	var _close_workshops = function( $container ) {
		$container.removeClass( 'open' );
		$container.find( '.workshops-collapse' ).slideUp();
	};

	var _maybe_open_workshops = function() {
		var $workshops = $( '.booking-card' ).find( '.workshops.pre-open' );

		if ( $workshops.length > 0 ) {
			$workshops.each( function() {
				_open_workshops( $( this ) );
			} )
		}
	};

	if ( $( '#account-bookings' ).length > 0 ) {
		_init();
	}

} ) ( jQuery );

module.exports = account_bookings;